import React, { Component } from 'react';



class SlideHome extends Component {
    render() {
        return (
            <section className="slide_main">
                <div id="myCarousel" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner" role="listbox">
                        <div className="item active"><img src="../../../img/home_image/banner01.jpg" data-src="../../../img/home_image/banner01.jpg" alt="Mordor Intelligence" width="460" height="345" />
                            <div className="carousel-caption ">
                                <div className="sli-txt">
                                    <div className="ttx animated bounce">
                                        <h3>EXPEDITE YOUR DECISION MAKING</h3>
                                        <h4>With Our Authoritative Research</h4>
                                    </div>
                                    <span className="hanging animated fadeInDownBig"><a href="/industry-reports">60+ Industry segments, extensively covered.&nbsp; &nbsp;<i className="fa fa-arrow-right"></i></a></span>

                                </div>
                            </div>
                        </div>
                    </div>

                    <a className="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
                        <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="right carousel-control" href="#myCarousel" role="button" data-slide="next">
                        <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </div>
            </section>
        );
    }
}

export default SlideHome;


// WEBPACK FOOTER //
// ./src/home/slide-home/slide-home.js